// extracted by mini-css-extract-plugin
export default {"innerWrapper":"SA-z","tooltipWrapper":"TA-z","icon":"UA-z","tooltip":"VA-z","content":"WA-z"};